export const educationData = [{
    year: '2017',
    name: 'Omkarananda Saraswati Nilayam',
    degree: 'Secondary School',
    grade: '93.16%',
    description: 'Scored 99 marks in Computers in ICSE board.',
}, {
    year: '2019',
    name: 'Omkarananda Saraswati Nilayam',
    degree: 'Higher Secondary School',
    grade: '94.4%',
    description: 'Scored 100 marks in Computers in ISC board.',
}, {
    year: '2023',
    name: 'Maharaja Agrasen Institute of Technology',
    degree: 'Bachelors of Technology - CSE',
    grade: '9.60 cgpa',
    description: 'Secured 2nd rank in the university in Second year.',
}];